import React, { useContext, useMemo } from "react";
import { createContext } from "react";

export interface IPerfil {
  idPerfil: string,
  permissoes: string[],
  idsEstabelecimentos: number[],
}

export interface IInformacoesDeUsuario {
  nome: string,
  email: string,
  login: string,
  isLoadingPerfisDeUsuario: boolean,
  isLoadingInformacoesDeUsuario: boolean,
  perfis: IPerfil[]
}

export interface IPerfilDeUsuarioProviderProps {
  informacoesDeUsuario: IInformacoesDeUsuario;
  children: React.ReactNode;
}


export const PerfilDeUsuarioContext = createContext<IInformacoesDeUsuario>({} as IInformacoesDeUsuario);

export const PerfilDeUsuarioProvider: React.FC<IPerfilDeUsuarioProviderProps> = ({ children, informacoesDeUsuario }) => {
  return (
    <PerfilDeUsuarioContext.Provider
      value={informacoesDeUsuario}>
      {children}
    </PerfilDeUsuarioContext.Provider>

  )
};

export const usePermissoes = () => {
  const context = useContext(PerfilDeUsuarioContext);
  const permissoes = useMemo(() => context.perfis?.flatMap(perfil => perfil.permissoes), [context]);
  return permissoes;
};



export const useTemPermissao = (permissao: string) => {
  const listaDePermissoes = usePermissoes();

  const temPermissao = useMemo(() => {
    if (listaDePermissoes?.includes(permissao)) {
      return false
    } else {
      return true
    }

  }, [listaDePermissoes])

  return temPermissao;
}

export const usePerfilDeUsuario = () => {
  const context = useContext(PerfilDeUsuarioContext);
  return context;
}

